import { render, staticRenderFns } from "./HrForm.vue?vue&type=template&id=47ad24b8&"
import script from "./HrForm.vue?vue&type=script&lang=js&"
export * from "./HrForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports